export default "__VITE_ASSET__BMvA_MqI__"